"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "prizzi": {
    "ba3ac9ba": [{
      "hkey": "c3b0ab42",
      "slug": "filaga",
      "name": "Filaga",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-filaga": [{
      "hkey": "c3b0ab42",
      "slug": "filaga",
      "name": "Filaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fe6a71ea": [{
      "hkey": "58e695dd",
      "slug": "prizzi",
      "name": "Prizzi",
      "primary": true,
      "skipSearch": false
    }],
    "portella-della-croce": [{
      "hkey": "58e695dd",
      "slug": "prizzi",
      "name": "Prizzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;